import { render, staticRenderFns } from "./LoanForm.vue?vue&type=template&id=8312a820&scoped=true"
import script from "./LoanForm.vue?vue&type=script&lang=js"
export * from "./LoanForm.vue?vue&type=script&lang=js"
import style0 from "./LoanForm.vue?vue&type=style&index=0&id=8312a820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8312a820",
  null
  
)

export default component.exports